var redefine = require('./_redefine');
module.exports = function(target, src, safe){
  for(var key in src)redefine(target, key, src[key], safe);
  return target;
};


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/core-js/modules/_redefine-all.js
// module id = 211
// module chunks = 0 3 5